import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authReducer from './slices/authSlice';
import keywordReducer from './slices/keywordSlice';
import notificationReducer from './slices/notificationSlice';
import jobReducer from './slices/jobSlice';
import individualReducer from './slices/individualSlice';
import registrationReducer from './slices/registrationSlice';
import activityReducer from './slices/activitySlice';
import chatReducer from './slices/chatSlice';
import notificationMiddleware from './middleware/notificationMiddleware';

//Useful refences:
// Immer with RTK: https://redux-toolkit.js.org/usage/immer-reducers
// asyncThunks: https://redux-toolkit.js.org/api/createAsyncThunk
// createSlice: https://redux-toolkit.js.org/api/createSlice
// configureStore: https://redux-toolkit.js.org/api/configureStore

const store = configureStore({
  reducer: {
    auth: authReducer,
    keyword: keywordReducer,
    notification: notificationReducer,
    jobs: jobReducer,
    individual: individualReducer,
    activity: activityReducer,
    registration: registrationReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(notificationMiddleware);
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
